import React from 'react';
import { IMaskInput } from 'react-imask';

interface TextMaskCustomProps extends React.InputHTMLAttributes<HTMLInputElement> {
  mask: string;
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  inputRef: (instance: HTMLInputElement | null) => void;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, TextMaskCustomProps>(
  function TextMaskCustom(props, ref) {
    const { mask, name, onChange, inputRef, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={mask}
        unmask
        definitions={{
          '#': /[1-9]/,
        }}
        inputRef={(el) => {
          if (ref) {
            if (typeof ref === 'function') {
              ref(el);
            } else {
              (ref as React.MutableRefObject<HTMLInputElement | null>).current = el;
            }
          }
          inputRef(el);
        }}
        onAccept={(value: string) => {
          onChange({ target: { name, value } });
        }}
        overwrite
      />
    );
  },
);

export default TextMaskCustom;
